<template>
  <div class="container mt-5">
      <div class="row " >
          <router-view/>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>